var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('iframe',{attrs:{"src":_vm.expertUrl,"width":"100%","height":"100%","border":"0","frameborder":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }